var _a;
import { Typographies } from '../utils/getThemeTypography';
export var FontWeights;
(function (FontWeights) {
    FontWeights[FontWeights["REGULAR"] = 400] = "REGULAR";
    FontWeights[FontWeights["MEDIUM"] = 500] = "MEDIUM";
    FontWeights[FontWeights["SEMI_BOLD"] = 600] = "SEMI_BOLD";
    FontWeights[FontWeights["BOLD"] = 700] = "BOLD";
})(FontWeights || (FontWeights = {}));
var typography = (_a = {},
    _a[Typographies.H1_HEADING] = {
        fontSize: '48px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a[Typographies.H2_HEADING] = {
        fontSize: '42px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a[Typographies.H3_HEADING] = {
        fontSize: '34px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.H4_HEADING] = {
        fontSize: '24px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a[Typographies.H5_HEADING] = {
        fontSize: '20px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.H6_HEADING] = {
        fontSize: '18px',
        fontWeight: FontWeights.SEMI_BOLD,
    },
    _a[Typographies.H7_HEADING] = {
        fontSize: '16px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a[Typographies.SUBTITLE] = {
        fontSize: '14px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a[Typographies.BUTTON] = {
        fontSize: '14px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a[Typographies.BODY1] = {
        fontSize: '14px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.BODY2] = {
        fontSize: '13px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.CAPTION] = {
        fontSize: '12px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.TOAST_CONTENT] = {
        fontStyle: 'normal',
        fontWeight: FontWeights.REGULAR,
        fontSize: '12px',
    },
    _a[Typographies.TOAST_TITLE] = {
        fontStyle: 'normal',
        fontWeight: FontWeights.SEMI_BOLD,
        fontSize: '13px',
    },
    _a[Typographies.LINK] = {
        fontStyle: 'normal',
        fontSize: '14px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.TAB] = {
        fontSize: '16px',
        fontWeight: FontWeights.REGULAR,
    },
    _a[Typographies.TAB_ACTIVE] = {
        fontSize: '16px',
        fontWeight: FontWeights.MEDIUM,
    },
    _a);
export default typography;
